import { render, staticRenderFns } from "./DataHealthButton.vue?vue&type=template&id=65950a2a&scoped=true"
import script from "./DataHealthButton.vue?vue&type=script&lang=js"
export * from "./DataHealthButton.vue?vue&type=script&lang=js"
import style0 from "./DataHealthButton.vue?vue&type=style&index=0&id=65950a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65950a2a",
  null
  
)

export default component.exports